"use strict";
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = __importStar(require("react"));
var utils_1 = require("@mui/material/utils");
var Icon = function (props) { return (React.createElement("svg", __assign({ xmlns: "http://www.w3.org/2000/svg", width: "1em", height: "1em", fill: "none", viewBox: "0 0 32 19" }, props),
    React.createElement("path", { fill: "currentColor", d: "M30.554 8.485 27.46 6.486 23.475.427A.928.928 0 0 0 22.7 0H6.065h.001c-.25 0-.49.104-.668.292-.176.186-.276.44-.276.703v2.76H3.836c-.522 0-.944.446-.944.996s.422.997.944.997h6.088c.52 0 .942-.446.942-.997 0-.55-.422-.996-.942-.996H7.008V1.992h12.054v5.235c0 .264.1.517.276.705a.919.919 0 0 0 .666.292h6.53l2.585 1.67v4.575l-.922-.002c-.285-1.464-1.47-2.541-2.884-2.62-1.413-.079-2.7.86-3.129 2.285h-7.287c-.432-1.434-1.731-2.376-3.154-2.284-1.422.091-2.603 1.192-2.866 2.671-.018-.001-.036-.006-.055-.006H7.01V12.55c.485-.083.828-.545.789-1.061-.04-.518-.448-.916-.94-.915h-5.01c-.522 0-.944.446-.944.995 0 .55.422.997.943.997h3.275v2.945c0 .264.1.518.277.704a.918.918 0 0 0 .667.291h2.756-.001a.885.885 0 0 0 .269-.045c.524 1.248 1.723 2.024 3.013 1.95 1.291-.076 2.402-.986 2.794-2.286h7.287c.392 1.3 1.503 2.21 2.794 2.285 1.29.075 2.489-.7 3.012-1.95h2.073c.25 0 .49-.103.666-.29a1.02 1.02 0 0 0 .276-.705V9.335c0-.347-.17-.669-.45-.85ZM20.95 1.992h1.258l2.788 4.24h-4.047v-4.24Zm-9.016 14.43c-.496 0-.942-.317-1.132-.799a1.344 1.344 0 0 1 .266-1.409c.35-.37.877-.48 1.334-.28.458.2.756.67.756 1.194 0 .713-.548 1.292-1.224 1.293Zm13.216 0c-.496 0-.943-.317-1.132-.799a1.347 1.347 0 0 1 .266-1.409c.35-.37.877-.48 1.334-.28.458.2.756.67.756 1.194 0 .713-.548 1.292-1.224 1.293Z" }),
    React.createElement("path", { fill: "currentColor", d: "M8.425 9.019c.52 0 .942-.446.942-.995 0-.55-.422-.997-.942-.997H.942c-.52 0-.942.447-.942.997s.422.995.942.995h7.483Z" }))); };
var SvgShipped = (0, utils_1.createSvgIcon)(React.createElement(Icon, null), 'SvgShipped');
exports.default = SvgShipped;
